import type { Branded } from '@festina-life/core'
import type { FC, JSX } from 'react'

import { useHook } from '../../lenteHooks'
import { NullReturn } from '../actions/NullReturn'

/**
 * HOC that will cause the wrapped to component to only be mounted when a `CommitmentVersion` exists.
 */
export const withCommitment = <T,>(
  WrappedComponent: FC<T>,
): Branded<FC, 'Area'> => {
  const WrapperComponent = (props: T & JSX.IntrinsicAttributes) => {
    const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
    const { data: commitmentVersion } = useHook(
      'fetchers.life.useFetchCommitmentVersionLatestNoSuspense',
    )({ ownerId, tenantId })

    return commitmentVersion ? <WrappedComponent {...props} /> : <NullReturn />
  }

  WrapperComponent.displayName = `${
    WrappedComponent.displayName || WrappedComponent.name || 'Unknown'
  }WrapperComponent`

  return WrapperComponent as Branded<FC, 'Area'>
}
